import { flushSync } from 'react-dom';
import { DS_AI_VIEW_TRANSITION_CLASS } from './viewTransition.constants';
import { prefersReducedMotion } from './theme/reducedMotion.utils';

/**
 * Runs a navigation as a View Transition: the old page cross-fades out while elements sharing a
 * `view-transition-name` morph into place. Without API support, or with reduced motion, the update just runs.
 */
export const runViewTransition = (update: () => void): void => {
	if (!('startViewTransition' in document) || prefersReducedMotion()) {
		update();
		return;
	}
	const root = document.documentElement;
	root.classList.add(DS_AI_VIEW_TRANSITION_CLASS);
	// Synchronous render, so the new page is in the DOM when the browser snapshots it.
	const transition = document.startViewTransition(() => flushSync(update));
	// A skipped transition rejects `ready`; the update has still run.
	void transition.ready.catch(() => undefined);
	void transition.finished
		.catch(() => undefined)
		.finally(() => root.classList.remove(DS_AI_VIEW_TRANSITION_CLASS));
};
